import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const regexEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const emailValidation = (value) =>
  regexEmail.test(value.trim()) && value.trim().length < 65;

const SigninWithEmail = (props) => {
  const [loading, setLoading] = useState(false);
  const [emailHasError, setEmailHasError] = useState(false); //email
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });  

  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }

    if (!emailValidation(userData.uid)) {
      setEmailHasError(true);
      return;
    }

    setEmailHasError(false);
    console.log("userData: ", userData);
    //post to server
    try {
      setLoading(true);
      const response = await axios.post("php/sign_in/signin.php", userData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("RAW RESPONSE", response);
      console.log("DATA", response.data);
      console.log("DATA MESSAGE", response.data);
      console.log("CALLNAME", response.data.callname);

      if (response.data.code !== 200) {
        if (response.data.code === 401) {
          alert(
            response.data?.message ||
              "Invalid credentials. Retry or use password help",
          );
        } else {
          alert(
            response.data?.message ||
              "Failed to sign in. Check your internet connection",
          );
        }
        return;
      }
      
      props.onLoggedIn({
        method: "email",
        callname: response.data.callname,
      });
    } catch (error) {
      const data = error?.response?.data;

      alert(
        data?.message ||
          "Invalid credentials or Error connecting to server. Please retry.",
      );
    } finally {
      setLoading(false);
    }
  };

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim().toLowerCase() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && emailHasError) {
      setEmailHasError(newValue ? !emailValidation(newValue) : false);
    }
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Email</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Enter your email"
          maxLength={65}
          required
          autoComplete="email"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
        {emailHasError && (
          <span className={styles.errorText}>Your email is invalid</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onEmailPasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithEmail;

/*2025 good
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const regex_email =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const emailValidation = (value) =>
  regex_email.test(value.trim()) && value.trim().length < 65;

const SigninWithEmail = (props) => {
  const [showSpinner, setShowSpinner] = useState();
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const [emailHasError, setEmailHasError] = useState();

  const [checked, setChecked] = useState(false);
  const checkboxType = (type) => {
    type === "password" ? (type = "text") : (type = "password");
    return type;
  };

  const checkboxChangeHandler = () => {
    const passwordInput = document.getElementById("password");
    setChecked(!checked);
    passwordInput.type = checkboxType(passwordInput.type);
  };

  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }
    if (!emailValidation(userData.uid.trim())) {
      setEmailHasError(true);
      return;
    } else setEmailHasError(false);
    console.log("userData: ", userData);
    //post to server
    try {
      setShowSpinner(true);
      const response = await axios.post("php/sign_in/signin.php", userData, {
      headers: {
          "Content-Type": "application/json",
      },
      });
      // Check the response
      console.log("response data: ", response.data);
      if (response.data == "Access denied" || response.data == 0) {
        alert(
            "Error connecting to server. Check your internet connection or retry later"
        );
      } else if (response.data == 1) {
        alert("Wrong email. Retry");
      } else if (response.data == 2) {
        alert("Wrong password. Retry");
      } else {
        props.onLoggedIn({
          method: "email",
          callname: response.data,
        });
      }
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      alert(`Error: ${error} Please retry`);
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Email</h2>
      </header>
      <div className={styles.inputView}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          placeholder="Enter your email"
          maxLength={24}
          required
          autoComplete="off"
          type="email"
          value={userData.uid}
          onChange={(e) =>
            setUserData({
              ...userData,
              uid: e.target.value.trim().toLowerCase(),
            })
          }
        />
        {emailHasError && (
          <span className={styles.errorText}>Your email is invalid</span>
        )}
      </div>
      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            type="password"
            id="password"
            placeholder="Enter your password"
            maxLength={15}
            required
            autoComplete="off"
            value={userData.password}
            onChange={(e) =>
              setUserData({
                ...userData,
                password: e.target.value.trim(),
              })
            }
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={checked}
            onChange={checkboxChangeHandler}
          />
        </div>
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
        >
          Submit
        </button>
        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onEmailPasswordHelpRequest}
        >
          Password help
        </button>
        <button className={styles.bgRed} onClick={props.onCancel}>
          Cancel
        </button>
      </div>
      {showSpinner && <Spinner />}
    </div>
  );
};

export default SigninWithEmail;
*/

/*
import SigninCredentialBase from "./SigninCredentialBase";

const regexEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const normalizeEmail = (value) => value.trim().toLowerCase();

const validateEmail = (value) =>
  regexEmail.test(value.trim()) && value.trim().length < 65;

const SigninWithEmail = (props) => {
  return (
    <SigninCredentialBase
      title="Sign in with your Email"
      uidLabel="Email"
      uidInputId="email"
      uidInputType="email"
      uidPlaceholder="Enter your email"
      uidMaxLength={64}
      uidAutoComplete="email"
      method="email"
      normalizeUid={normalizeEmail}
      validateUid={validateEmail}
      invalidUidMessage="Your email is invalid"
      passwordHelpHandler={props.onEmailPasswordHelpRequest}
      onCancel={props.onCancel}
      onLoggedIn={props.onLoggedIn}
    />
  );
};

export default SigninWithEmail;
*/

/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import { useAuthSubmit } from "../../../../auth/useAuthSubmit";

const regexEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const emailValidation = (value) =>
  regexEmail.test(value.trim()) && value.trim().length < 65;

const SigninWithEmail = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [emailHasError, setEmailHasError] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const { submit, loading } = useAuthSubmit(
    "php/sign_in/signin.php",
    "email",
    props.onLoggedIn,
  );

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim().toLowerCase() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && emailHasError) {
      setEmailHasError(false);
    }
  };

  const submitHandler = () => {
    if (loading) return;

    const uid = userData.uid.trim().toLowerCase();
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill all fields correctly.");
      return;
    }

    if (!emailValidation(uid)) {
      setEmailHasError(true);
      return;
    }

    setEmailHasError(false);

    submit({
      uid,
      password,
    });
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Email</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Enter your email"
          maxLength={64}
          required
          autoComplete="email"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
        {emailHasError && (
          <span className={styles.errorText}>Your email is invalid</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onEmailPasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithEmail;

/*
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import { useAuthSubmit } from "../../../../auth/useAuthSubmit";

const regexEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const emailValidation = (value) =>
  regexEmail.test(value.trim()) && value.trim().length < 73;

const SigninWithEmail = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [emailHasError, setEmailHasError] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const { submit, loading } = useAuthSubmit(
    "php/sign_in/signin.php",
    "email",
    props.onLoggedIn,
  );

  const inputChangeHandler = (field, value) => {
    const newValue = field === "uid" ? value.trim().toLowerCase() : value;

    setUserData((prev) => ({
      ...prev,
      [field]: newValue,
    }));

    if (field === "uid" && emailHasError) {
      setEmailHasError(false);
    }
  };

  const submitHandler = () => {
    if (loading) return;

    const uid = userData.uid.trim().toLowerCase();
    const password = userData.password;

    if (!uid || !password) {
      alert("Please fill all fields correctly.");
      return;
    }

    if (!emailValidation(uid)) {
      setEmailHasError(true);
      return;
    }

    setEmailHasError(false);

    submit({
      uid,
      password,
    });
  };

  const keyDownHandler = (e) => {
    if (e.key === "Enter") {
      submitHandler();
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Email</h2>
      </header>

      <div className={styles.inputView}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Enter your email"
          maxLength={64}
          required
          autoComplete="email"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          onKeyDown={keyDownHandler}
          disabled={loading}
        />
        {emailHasError && (
          <span className={styles.errorText}>Your email is invalid</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            onKeyDown={keyDownHandler}
            disabled={loading}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label="Show"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>

      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onEmailPasswordHelpRequest}
          disabled={loading}
        >
          Password help
        </button>

        <button
          className={styles.bgRed}
          type="button"
          onClick={props.onCancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>

      {loading && <Spinner />}
    </div>
  );
};

export default SigninWithEmail;
*/
/*
Next:
import { useState } from "react";
import Spinner from "../../../ui/spinner/Spinner";
import Checkbox from "../../../ui/checkbox/Checkbox";
import styles from "./OptionsStyles.module.css";
import axios from "axios";

const regex_email =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const emailValidation = (value) =>
  regex_email.test(value.trim()) && value.trim().length < 65;

const SigninWithEmail = (props) => {
  const [showSpinner, setShowSpinner] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    password: "",
  });

  const [emailHasError, setEmailHasError] = useState();

  const inputChangeHandler = (field, value) => {
    setUserData((prev) => ({
      ...prev,
      [field]: field === "uid" ? value.trim().toLowerCase() : value,
    }));
  };

  const submitHandler = async () => {
    if (!userData.uid || !userData.password) {
      alert("Error detected", "Please fill all fields correctly");
      return;
    }
    if (!emailValidation(userData.uid.trim())) {
      setEmailHasError(true);
      return;
    } else setEmailHasError(false);
    console.log("userData: ", userData);
    //post to server
    try {
      setShowSpinner(true);

      const res = await axios.post(
        "php/sign_in/signin.php",
        {
          uid: userData.uid,
          password: userData.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );

      console.log("Server response:", res.data);

      if (res.data?.status !== "success") {
        throw new Error(res.data?.message || "Sign-in failed.");
      }

      props.onLoggedIn({
        method: "email",
        callname: res.data.callname,
      });
    } catch (error) {
      console.error("Sign-in error:", error);

      const message =
        error.response?.data?.message ||
        error.message ||
        "Please retry or use another method.";

      alert(`Your sign-in credential failed. ${message}`);
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <div className={styles.classes}>
      <header>
        <h2>Sign in with your Email</h2>
      </header>
      <div className={styles.inputView}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Enter your email"
          maxLength={64}
          required
          autoComplete="email"
          value={userData.uid}
          onChange={(e) => inputChangeHandler("uid", e.target.value)}
          disabled={showSpinner}
        />
        {emailHasError && (
          <span className={styles.errorText}>Your email is invalid</span>
        )}
      </div>
      <div className={styles.inputView}>
        <label htmlFor="password">Password</label>
        <div className={styles.flex}>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            maxLength={72}
            required
            autoComplete="current-password"
            value={userData.password}
            onChange={(e) => inputChangeHandler("password", e.target.value)}
            disabled={showSpinner}
          />
          <Checkbox
            labelClassname={styles.checkboxLabel}
            inputClassname={styles.checkbox}
            label={"Show"}
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
        </div>
      </div>
      <div className={styles.btnDiv}>
        <button
          className={styles.bgGreen}
          type="button"
          onClick={submitHandler}
        >
          Submit
        </button>
        <button
          className={styles.bgBlue}
          type="button"
          onClick={props.onEmailPasswordHelpRequest}
        >
          Password help
        </button>
        <button className={styles.bgRed} onClick={props.onCancel}>
          Cancel
        </button>
      </div>
      {showSpinner && <Spinner />}
    </div>
  );
};

export default SigninWithEmail;
*/
